import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Dashboard from "./Dashboard";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

// Disable pinch and double-tap zoom to keep app at 100%
// Note: Disabling zoom can affect accessibility. Requested by project requirements.
(() => {
	// iOS Safari pinch gestures
	const prevent = (e) => e.preventDefault();
	["gesturestart", "gesturechange", "gestureend"].forEach((evt) => {
		document.addEventListener(evt, prevent);
	});

	// Desktop/mobile browsers: Ctrl/Cmd + wheel zoom
	window.addEventListener(
		"wheel",
		(e) => {
			if (e.ctrlKey || e.metaKey) {
				e.preventDefault();
			}
		},
		{ passive: false }
	);

	// Fallback for double-tap zoom on older iOS
	let lastTouchEnd = 0;
	document.addEventListener(
		"touchend",
		(e) => {
			const now = Date.now();
			if (now - lastTouchEnd <= 300) {
				e.preventDefault();
			}
			lastTouchEnd = now;
		},
		{ passive: false }
	);
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<App />} />
				<Route path="/dashboard" element={<Dashboard />} />
			</Routes>
		</BrowserRouter>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
